import { OPTIMIZELY, type OptimizelyAction } from '../actions/optimizelyActions';

export const optimizelyInitialState = [];

export function optimizelyReducer(state = optimizelyInitialState, action: OptimizelyAction) {
  switch (action.type) {
    case OPTIMIZELY.SET_OPTIMIZELY_SETTING: {
      return [...state, ...action.payload];
    }

    default: {
      return state;
    }
  }
}

export default optimizelyReducer;
